'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

export default function ScrollToHere() {
  // when clicking a link, user will not scroll to the top of the page if the header is sticky.
  // their current scroll position will persist to the next page.
  // this useEffect is a workaround to 'fix' that behavior.

  const pathname = usePathname()

  useEffect(() => {
    if (typeof window === 'undefined') {
      console.error('window is undefined')
      return
    }

    const hash = window.location.hash ? window.location.hash : null
    const targetEl = hash ? document.querySelector(hash) : null

    // Scroll to the target element if it exists
    if (targetEl) {
      targetEl.scrollIntoView({
        behavior: 'instant',
        block: 'start',
      })

      // Scroll to the top of the page if no hash is present
    } else {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant',
      })
    }
  }, [pathname])
  return <></>
}
